import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Personal listening shell.
 *
 * Intentionally not event-backed. This route is only the home entry destination.
 */
export default function PersonalListenScreen() {
  const navigate = useNavigate();

  return (
    <div className="rhythm-page bg-gradient-to-b from-gray-900 to-black">
      <div className="rhythm-page-shell rhythm-page-shell--home" data-testid="personal-listen-shell">
        <header className="text-center space-y-2">
          <h1 className="text-2xl font-semibold text-white tracking-tight">Listen for Yourself</h1>
          <p className="text-sm text-gray-400">Your music. Your preferences. Your space.</p>
        </header>

        <p className="text-center text-sm text-gray-500">Personal listening is coming soon.</p>

        <button
          type="button"
          onClick={() => navigate('/')}
          className="rhythm-home-cta w-full rounded-xl bg-white/10 font-semibold text-white hover:bg-white/20 transition-colors"
        >
          Back to home
        </button>
      </div>
    </div>
  );
}
